import { render, staticRenderFns } from "./CompareChart.vue?vue&type=template&id=10688e2c&scoped=true"
import script from "./CompareChart.vue?vue&type=script&lang=js"
export * from "./CompareChart.vue?vue&type=script&lang=js"
import style0 from "./CompareChart.vue?vue&type=style&index=0&id=10688e2c&prod&scoped=true&lang=css"
import style1 from "./CompareChart.vue?vue&type=style&index=1&id=10688e2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10688e2c",
  null
  
)

export default component.exports